import loadable from '@loadable/component';

export const Component = loadable(
  () => import('./containers/CancellationBlockContainer')
);
export { default as propsFormatter } from './propsFormatter';
